import { FilterFormService } from "app/views/filter_form/filter_form.service";
import merge from 'lodash-es/merge';
import * as qs from 'qs';
import * as moment from 'moment-timezone';
import { getServerName } from "app/lib/lib";
import { TranslateService } from '../translate';
import * as dictionary from "../../dict/static.json";
// Добавить typed.d и в него - dictionary. И убрать эту порнуху
var config = dictionary['config'];
var locations = dictionary['locations'];
var socialFilter = dictionary['socialFilter'];
var serverAliasList = dictionary['serverAliasList'];
var serverZoneList = dictionary['serverZoneList'];
var subjectList = dictionary['subjectList'];
var templateList = dictionary['templateList'];
var processorList = dictionary['processorList'];
var currencyList = dictionary['currencyList'];
var tariffVariantList = dictionary['tariffVariantList'];
var tariffIdList = dictionary['tariffIdList'];
var localesMap = dictionary['localesMap'];
var convertAmountToDollarHash = {
    'all': '$',
    'rub': 'R',
    'usd': '$',
    'brl': 'R$',
    'ngn': '₦',
    'pln': 'zł',
}, utmList = [
    'utm_source', 'utm_medium', 'utm_campaign',
    'utm_term', 'utm_content', 'utm_landing',
    'gclid'
];
var SiteHelper = /** @class */ (function () {
    function SiteHelper() {
    }
    SiteHelper.getDomainUrl = function (site) {
        return "https://" + (site._source === 1 ? '' : 'c2.') + "ukit.com/sites/url/" + site.url + "/dashBoard";
    };
    return SiteHelper;
}());
var HelperService = /** @class */ (function () {
    function HelperService(filterService, _translate) {
        this.filterService = filterService;
        this._translate = _translate;
        this.site = SiteHelper;
        this.currencyLabels = {
            all: 'All',
            usd: '$',
            rub: '₽',
            brl: 'R$',
            pln: 'zł',
            ngn: '₦',
            ukt: 'UKT'
        };
    }
    Object.defineProperty(HelperService.prototype, "locations", {
        get: function () { return locations; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "socialFilter", {
        get: function () { return socialFilter; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "serverAliasList", {
        get: function () { return serverAliasList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "serverZoneList", {
        get: function () { return serverZoneList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "subjectList", {
        get: function () { return subjectList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "templateList", {
        get: function () { return templateList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "processorList", {
        get: function () { return processorList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "currencyList", {
        get: function () { return currencyList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "tariffVariantList", {
        get: function () { return tariffVariantList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "tariffIdList", {
        get: function () { return tariffIdList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService.prototype, "localesMap", {
        get: function () {
            return Object.keys(localesMap).reduce(function (obj, key) {
                obj[key] = localesMap[key];
                return obj;
            }, {
                'all': this._translate.instant('adminstat.common.any'),
                'not_ru': 'not_ru'
            });
        },
        enumerable: true,
        configurable: true
    });
    HelperService.prototype.getUrlParams = function (queryParams, addParams) {
        var params;
        if (addParams) {
            Object.keys(addParams).forEach(function (p) {
                if (addParams[p]) {
                    var data = {};
                    data[p] = addParams[p];
                    queryParams = merge({}, queryParams, data);
                }
            });
        }
        params = merge({}, this.filterService.getDiffParams(queryParams), { t: Date.now() });
        params.chartFormat = 'c3angular';
        return qs.stringify(params, { encode: false });
    };
    HelperService.prototype.percentageFormat = function (number) {
        return (isNaN(number) ? '0' : Math.floor(number * 1000) / 10) + '%';
    };
    HelperService.prototype.convertAmountToDollar = function (amount, postfix) {
        if (!amount) {
            return '0';
        }
        var newAmount = parseInt(amount, 10) / 100;
        if (!postfix) {
            return newAmount.toString();
        }
        return newAmount + " " + (convertAmountToDollarHash[postfix] || postfix);
    };
    HelperService.prototype.getTimeAsIntervals = function (opts) {
        var start = opts.timestamp, period = opts.period, dates = [];
        if (period == 'day') {
            dates = [
                moment.utc(start).add(3, 'hour').startOf('day').format('DD.MM.YYYY'),
            ];
        }
        else {
            if (period == 'week') {
                dates = [
                    moment.utc(start).add(3, 'hour').startOf('isoWeek').format('DD.MM.YYYY'),
                    moment.utc(start).add(3, 'hour').endOf('isoWeek').format('DD.MM.YYYY')
                ];
            }
            else if (period == 'month') {
                dates = [
                    moment.utc(start).add(3, 'hour').startOf('month').format('DD.MM.YYYY'),
                    moment.utc(start).add(3, 'hour').endOf('month').format('DD.MM.YYYY')
                ];
            }
            else if (period == 'year') {
                dates = [
                    moment.utc(start).add(3, 'hour').startOf('year').format('DD.MM.YYYY'),
                    moment.utc(start).add(3, 'hour').endOf('year').format('DD.MM.YYYY')
                ];
            }
            else if (period == 'summary') {
                dates = [
                    ''
                ];
            }
        }
        return dates;
    };
    /**
     * Ограничить вызов fn в интервале limit миллисекунд
     * @param {Function} fn
     * @param {number} limit
     *
     * @return {Function} Функция, которая будет вызвана не чаще чем раз в limit миллисекунд
     */
    HelperService.prototype.delimit = function (fn, limit) {
        if (limit === void 0) { limit = 1000; }
        var timer = null;
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () { return fn.apply(_this, args); }, limit);
        };
    };
    HelperService.prototype.getUtmList = function () {
        return utmList;
    };
    HelperService.prototype.getServerHost = function () {
        return "http://" + getServerName();
    };
    HelperService.prototype.getSupportUrl = function (opts) {
        if (!opts) {
            throw new Error('helper.service.openSupportPage error: opts is not define!');
        }
        var key = [
            'site', 'siteId',
            'email', 'userId',
            'invoiceNumber',
            'username',
        ].find(function (key) { return opts[key]; });
        var params = {
            typeFilter: key,
            value: opts[key]
        };
        if (key === 'site') {
            params['accurateSiteSearch'] = true;
        }
        return config.baseUrl + "/support?" + qs.stringify(params, { encode: false });
    };
    HelperService.prototype.getDashboarUrl = function (site) {
        return "https://" + (site._source === 1 ? '' : 'c2.') + getServerName() + "/sites/url/" + site.url + "/dashBoard";
    };
    return HelperService;
}());
export { HelperService };
